import React from "react";
import { IIconProps } from "./Icon/Interfaces";

const AddIcon = ({
  width = 21,
  height = 22,
  strokeColor = "var(--blue)",
}: IIconProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 17 16" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.575 0c-.59 0-1.067.478-1.067 1.067v5.867H1.641a1.067 1.067 0 1 0 0 2.133h5.867v5.866a1.067 1.067 0 1 0 2.134 0V9.067h5.866a1.067 1.067 0 0 0 0-2.133H9.642V1.067C9.642.477 9.164 0 8.575 0z"
        fill={strokeColor}
      />
    </svg>
  );
};

export default AddIcon;
